import { render, staticRenderFns } from "./paymentInit.vue?vue&type=template&id=0bd5fada"
import script from "./paymentInit.vue?vue&type=script&lang=js"
export * from "./paymentInit.vue?vue&type=script&lang=js"
import style0 from "./paymentInit.vue?vue&type=style&index=0&id=0bd5fada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports